import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Spinner from "./Spinner";
import { AUTH_CONFIG } from "../config";

const ProtectedRoute = ({ token, allowedRoles, children }) => {
  const location = useLocation();
  const hasStoredSession =
    localStorage.getItem(AUTH_CONFIG.TOKEN_KEY) ||
    localStorage.getItem(AUTH_CONFIG.REFRESH_TOKEN_KEY);

  if (token === undefined || (!token && hasStoredSession)) {
    return <Spinner />;
  }

  if (!token) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(
          `${location.pathname}${location.search}`
        )}`}
        replace
      />
    );
  }

  try {
    const payload = jwtDecode(token);
    const userRole = payload.role;
    const isAuthorized =
      !allowedRoles || allowedRoles.length === 0
        ? true
        : allowedRoles.includes(userRole);

    if (!isAuthorized) {
      return <Navigate to="/login" replace />;
    }

    return children;
  } catch (error) {
    console.error("Error decoding token:", error);
    return <Navigate to="/login?reason=session-expired" replace />;
  }
};

export default ProtectedRoute;
